// ImageSlider.jsx

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CommonImageSliderRanks = (props) => {
  return (
    <div className="w-full max-w-6xl mx-auto mt-2">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={4}
        slidesPerView={4}
        navigation={false}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop
        className="rounded-xl overflow-hidden shadow-md"
      >
        {props.images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div className="w-full">
              <img
                 
                src={img}
                alt={`Slide ${idx + 1}`}
                className="w-full h-full object-contain border border-[black]  p-[3px] rounded-2xl bg-gradient-to-tr from-green-400 via-yellow-300 to-pink-500"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CommonImageSliderRanks;
